var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactCheckRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H18C19.1 18 20 17.1 20 16V2C20 0.9 19.1 0 18 0ZM7 14H4C3.45 14 3 13.55 3 13C3 12.45 3.45 12 4 12H7C7.55 12 8 12.45 8 13C8 13.55 7.55 14 7 14ZM7 10H4C3.45 10 3 9.55 3 9C3 8.45 3.45 8 4 8H7C7.55 8 8 8.45 8 9C8 9.55 7.55 10 7 10ZM7 6H4C3.45 6 3 5.55 3 5C3 4.45 3.45 4 4 4H7C7.55 4 8 4.45 8 5C8 5.55 7.55 6 7 6ZM16.7 8.12L13.53 11.29C13.14 11.68 12.5 11.68 12.11 11.29L10.7 9.87C10.31 9.48 10.31 8.85 10.7 8.46C11.09 8.07 11.72 8.07 12.11 8.46L12.82 9.17L15.29 6.7C15.68 6.31 16.31 6.31 16.7 6.7L16.71 6.71C17.09 7.1 17.09 7.74 16.7 8.12Z",
    fill: "#B2D7C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactCheckRounded);
export default __webpack_public_path__ + "static/media/fact_check_rounded.d3c2d0c189551c51827b10355f181b11.svg";
export { ForwardRef as ReactComponent };